import toast from 'react-hot-toast';
import Icon from '@/components/iconfont/Icon.jsx';
import { reportData } from './trackingPoint';

const TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

const ICON = {
  [TYPE.INFO]: 'icon-info',
  [TYPE.SUCCESS]: 'icon-check-stroke',
  [TYPE.WARNING]: 'icon-info',
  [TYPE.ERROR]: 'icon-close-solid',
};

const OPENED_TOAST_IDS = new Set();

function create(
  content,
  type,
  { duration = 5000, position = 'center', id, confirmCb, isMobile } = {},
) {
  reportData('Toast', {
    'toast-text': content,
  });
  if (id && OPENED_TOAST_IDS.has(id)) {
    return Promise.resolve();
  }

  id = toast(
    (t) => (
      <div
        className={`${isMobile ? 'alert mobileAlert' : 'alert'} ${type === TYPE.INFO ? 'alert-info' : ''} ${type === TYPE.SUCCESS ? 'alert-success' : ''} ${type === TYPE.WARNING ? 'alert-warning' : ''} ${type === TYPE.ERROR ? 'alert-error' : ''}`}>
        <Icon name={ICON[type]}></Icon>
        <p>{content}</p>
        {confirmCb && (
          <button
            className="btn btn-outline btn-xs"
            onClick={() => {
              toast.dismiss(t.id);
              confirmCb();
            }}>
            Got it
          </button>
        )}
      </div>
    ),
    {
      duration,
      position: `top-${position}`,
      className: 'custom-toast',
      id,
    },
  );
  OPENED_TOAST_IDS.add(id);
  let rejectCb;
  let timeout;
  const promise = new Promise((resolve, reject) => {
    timeout = setTimeout(() => {
      OPENED_TOAST_IDS.delete(id);
      resolve();
    }, duration);
    rejectCb = reject;
  });
  promise.close = () => {
    clearTimeout(timeout);
    toast.dismiss(id);
    OPENED_TOAST_IDS.delete(id);
    rejectCb();
  };
  return promise;
}

export function info(content, options) {
  return create(content, TYPE.INFO, options);
}

export function success(content, options) {
  return create(content, TYPE.SUCCESS, options);
}

export function warning(content, options) {
  return create(content, TYPE.WARNING, options);
}

export function error(content, options) {
  return create(content, TYPE.ERROR, options);
}
export function close() {
  // 关闭所有toast
  toast.dismiss();
  OPENED_TOAST_IDS.clear();
}

export default {
  info,
  success,
  warning,
  error,
  close,
};
